// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* background-color: #F2F3FC !important; */
}

/* .material-symbols-outlined{
	font-size: 14px !important;
} */
/* .btn-primary{
	background-color: #358696 !important;
    border-color: #358696 !important;
} */

/* .btn-outline-primary{
	color:#358696 ;
	border-color:#358696;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#358696;
	color:#fff;
} */

/* .chargingMainDiv .btn-outline-primary {
  color: #358696 !important;
  border-color: #358696 !important;
}

.chargingMainDiv .btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
  background-color: #358696 !important;
  color: #fff !important;
}

.highlightBoxKpi .btn-outline-primary {
  color: #358696 !important;
  border-color: #358696 !important;
}

.highlightBoxKpi .btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
  background-color:  #358696 !important;
  color: #fff !important;
} */

.chargingMainDiv .btn-primary {
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/* k */
.chargingMainDiv .btn-outline-primary {
  border-color: #358696 !important;
  color: #358696 !important;
}


.chargingMainDiv .ev_filter_icon {
  background: #fff !important;
  color: #348393 !important;
}


.chargingMainDiv .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/*********************** Slow Button *************************/
.kpiSlowBTN .btn-outline-primary {
  /* color:#358696; */
  border-color: #358696 !important;
}

.kpiSlowBTN .btn-check:checked+.btn:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible,
.btn:first-child:active:focus-visible,
:not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}

.kpiSlowBTN .btn-outline-primary {
  --bs-btn-color: #358696 !important;
  --bs-btn-border-color: #358696 !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #358696 !important;
  --bs-btn-hover-border-color: #358696 !important;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #358696 !important;
  --bs-btn-active-border-color: #358696 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #358696 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #358696 !important;
  --bs-gradient: none;
}

.kpiSlowBTN .btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
  /* color: #fff; */
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/* .kpiSlowBTN .ev_SButton {
    background: none !important;
    color: #348393 !important;
  } */
.kpiSlowBTN .ev_SButton {
  background: none !important;
  color: #7b7878 !important;
  border-color: #7b7878 !important;
}

.kpiSlowBTN .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #358696 !important;
  border-color: #358696 !important;
}

.kpiSlowBTN .btn-outline-primary:hover {
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/*********************** Slow Button Ends *************************/


/*********************** Fast Button *************************/
.kpiFastBTN .btn-outline-warning {
  /* color:#FFA650; */
  /* border-color:#FFA650 !important; */
}

.kpiFastBTN .btn-check:checked+.btn:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible,
.btn:first-child:active:focus-visible,
:not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}

.kpiFastBTN .btn-outline-warning {
  --bs-btn-color: #FFA650 !important;
  --bs-btn-border-color: #FFA650 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFA650 !important;
  --bs-btn-hover-border-color: #FFA650 !important;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFA650 !important;
  --bs-btn-active-border-color: #FFA650 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFA650 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFA650 !important;
  --bs-gradient: none;
}

/* .kpiFastBTN .ev_FButton {
  background: none !important;
  color: #FFA650 !important;
} */
.kpiFastBTN .ev_FButton {
  background: none !important;
  /* color: #FFA650 !important; */
  /* background: #7b7878 !important; */
  /* border: #7b7878; */
  border-color: #7b7878;
}

.kpiFastBTN .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #FFA650;
  border-color: #FFA650;
}


/*********************** Fast Button Ends *************************/

has context menu .bg-white {
  background-color: #fff;
}

.chargingMainDiv {
  margin-top: 80px;
}

.chargingWidget {
  background: #fff;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  border-radius: 5px;
}

.chargingWidgetIcon img {
  width: 50px;
  height: 50px;
}

.chargingWidgetIcon1 img {
  width: 35px;
  height: 35px;
}

.chargingWidgetIcon-32 img {
  width: 32px;
  height: 32px;
}

.chargingTitleBg {
  font-size: 1em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
}

.chargingTitleChart {
  font-size: 0.8em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
}

.chargingChartbox {
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  color: #353535;
  min-height: 280px;
  border-radius: 5px;
}

.wd {
  min-height: 328px !important;
}

.wd_4_charts {
  min-height: 307px !important;
}

.highlightBoxKpi {
  min-height: 310px !important;
}

.highlightTableSec {
  min-height: 310px !important;
}

.chargingChartHGT {
  padding: 10px;
}

.chargingH5 .h5 {
  font-size: 1rem !important;
}

.chargingKpiSmallTxt {
  font-size: 77% !important;
  line-height: 1em !important;
}

.tableContent table tr td {
  font-size: 0.8em;
}

.chargingFilterForm>.form-label {
  font-size: 0.825em;
}

.chargingHeadfont {
  font-size: 1.8rem;
}

.topRightDropMenu .dropdown-menu[data-bs-popper] {
  right: 0 !important;
  left: auto;
}

/********************  *********************/

.contentScroll {
  /* overflow-y: scroll; */
  /* height:150px; */
}

.chargingWidget p {
  line-height: 1rem !important;
}

.chargingWidget p small {
  font-size: 80% !important;
}

/***************************** Toggle Switch ***************************/
.toggleBtn .form-switch .form-check-input:checked:before {
  content: "F";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 20px;
  margin-top: -1px;
  font-size: 0.7em;
}

.toggleBtn .form-switch .form-check-input:before {
  content: "S";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 5px;
  margin-top: -1px;
  font-size: 0.7em;
}

.toggleBtn .form-switch .form-check-input {
  color: #358696 !important;
}

/* k */
.toggleBtn .toggle-button-cover {
  position: relative;
  top: 8px;
  /* display: table-cell; */
  /* width: 200px; */
  /* height: 140px; */
  /* box-sizing: border-box; */
}

.dropdownSelectBtnCharging {
  width: fit-content;
}

.toggleBtn .button-cover {
  /* height: 100px; */
  /* margin: 20px; */
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.toggleBtn .button-cover:before {
  /* counter-increment: button-counter; */
  /* content: counter(button-counter); */
  /* position: absolute; */
  /* right: 0; */
  /* bottom: 0; */
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.toggleBtn .button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.toggleBtn .buttonbtn {
  position: relative;
  top: 50%;
  width: 50px;
  /* height: 36px; */
  /* margin: -20px auto 0 auto; */
  /* overflow: hidden; */
}

.toggleBtn .buttonbtn.r,
.buttonbtn.r .layer {
  border-radius: 100px;
}

.toggleBtn .button.b2 {
  border-radius: 2px;
}

.toggleBtn .checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.toggleBtn .knobs {
  z-index: 2;
}

.toggleBtn .layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 1 */
#button-1 .knobs:before {
  content: "S";
  position: absolute;
  /* top: 2px; */
  /* left: 4px; */
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 6px 4px;
  background-color: #358696;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1 .checkbox:checked+.knobs:before {
  content: "F";
  /* left: 25px; */
  left: 30px;
  background-color: #FFA650;
}

#button-1 .checkbox:checked~.layer {
  background-color: #fcebeb;
}

#button-1 .knobs,
#button-1 .knobs:before,
#button-1 .layer {
  transition: 0.3s ease all;
}

/* k */


/***************************** PageTwo *******************************/

/*************************  *****************************/
.kpiNotificationSlow {
  color: #358696;
  font-size: 0.7em;
  font-weight: 500;
}

.kpiNotificationFast {
  color: #FFA650;
  font-size: 0.7em;
  font-weight: 500;
}

.kpiNotificationBoth {
  color: #72D817;
  font-size: 0.7em;
  font-weight: 500;
}

/* media queries start here */

@media (min-width: 1440px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}

@media (max-width: 1440px) {
  .highlightTableSec {
    min-height: 310px !important;
  }
}

@media (min-width: 1336px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}


@media (max-width: 1024px) {
  .highlightTableSec {
    min-height: 330px !important;
  }
}


@media (min-width: 992px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}


@media (min-width: 836px) {
  /* .navbar-expand-sm { */
  /* flex-wrap: nowrap !important; */
  /* justify-content: flex-start !important; */
  /* } */
}

@media screen and (max-width: 740px) {
  .chargingTitleBg {
    font-size: 0.9em;
  }
}


@media screen and (max-width: 720px) {
  /* .chargingMainDiv{ */
  /* margin-top:124px; */
  /* } */
}

@media screen and (max-width: 480px) {
  /* .chargingMainDiv{ */
  /* margin-top:155px; */
  /* } */
}

@media screen and (max-width: 480px) {

  .chargingHeadfont {
    font-size: 1rem;
  }

  .chargingTitleBg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 320px) {}

.highlight_five {
  margin: auto;
}

.text_bottom {
  margin-bottom: '-16px !important';
  display: none;
  z-index: 1;
}

.btn-infotable:active {
  color: black;
  background-color: #fff;
  border-color: #32879c;

}

/* .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  color: #fff;
  color: black;
  background: none;
} */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Charginganalysis/ChargingPageCustom.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG;;AAEH;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,MAAM;AACN;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;;AAGA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;;AAGA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,uCAAuC;EACvC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;KAGK;AACL;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,mEAAmE;;;AAGnE,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,sCAAsC;EACtC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;GAGG;AACH;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA,mEAAmE;;AAEnE;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,4CAA4C;;AAE5C;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,MAAM;AACN;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,MAAM;;;AAGN,sEAAsE;;AAEtE,yDAAyD;AACzD;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;;AAGA;EACE;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;;AAGA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,4CAA4C;EAC5C,MAAM;AACR;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,MAAM;AACR;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;;AAEtC;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;;AAEvB;;AAEA;;;;;GAKG","sourcesContent":["body {\r\n  /* background-color: #F2F3FC !important; */\r\n}\r\n\r\n/* .material-symbols-outlined{\r\n\tfont-size: 14px !important;\r\n} */\r\n/* .btn-primary{\r\n\tbackground-color: #358696 !important;\r\n    border-color: #358696 !important;\r\n} */\r\n\r\n/* .btn-outline-primary{\r\n\tcolor:#358696 ;\r\n\tborder-color:#358696;\r\n}\r\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\r\n\tbackground-color:#358696;\r\n\tcolor:#fff;\r\n} */\r\n\r\n/* .chargingMainDiv .btn-outline-primary {\r\n  color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n.chargingMainDiv .btn-outline-primary:hover,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:visited,\r\n.btn-outline-primary:active,\r\n.btn-check:checked+.btn,\r\n.btn.active,\r\n.btn.show,\r\n.btn:first-child:active,\r\n:not(.btn-check)+.btn:active {\r\n  background-color: #358696 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.highlightBoxKpi .btn-outline-primary {\r\n  color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n.highlightBoxKpi .btn-outline-primary:hover,\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary:visited,\r\n.btn-outline-primary:active,\r\n.btn-check:checked+.btn,\r\n.btn.active,\r\n.btn.show,\r\n.btn:first-child:active,\r\n:not(.btn-check)+.btn:active {\r\n  background-color:  #358696 !important;\r\n  color: #fff !important;\r\n} */\r\n\r\n.chargingMainDiv .btn-primary {\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n/* k */\r\n.chargingMainDiv .btn-outline-primary {\r\n  border-color: #358696 !important;\r\n  color: #358696 !important;\r\n}\r\n\r\n\r\n.chargingMainDiv .ev_filter_icon {\r\n  background: #fff !important;\r\n  color: #348393 !important;\r\n}\r\n\r\n\r\n.chargingMainDiv .btn:focus,\r\n.btn:focus-visible,\r\n.btn:focus-within,\r\n.btn:hover,\r\n.btn:visited,\r\n.btn:active,\r\n.btn:target {\r\n  color: #fff !important;\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n/*********************** Slow Button *************************/\r\n.kpiSlowBTN .btn-outline-primary {\r\n  /* color:#358696; */\r\n  border-color: #358696 !important;\r\n}\r\n\r\n.kpiSlowBTN .btn-check:checked+.btn:focus-visible,\r\n.btn.active:focus-visible,\r\n.btn.show:focus-visible,\r\n.btn:first-child:active:focus-visible,\r\n:not(.btn-check)+.btn:active:focus-visible {\r\n  box-shadow: none;\r\n}\r\n\r\n.kpiSlowBTN .btn-outline-primary {\r\n  --bs-btn-color: #358696 !important;\r\n  --bs-btn-border-color: #358696 !important;\r\n  --bs-btn-hover-color: #fff;\r\n  --bs-btn-hover-bg: #358696 !important;\r\n  --bs-btn-hover-border-color: #358696 !important;\r\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\r\n  --bs-btn-active-color: #fff;\r\n  --bs-btn-active-bg: #358696 !important;\r\n  --bs-btn-active-border-color: #358696 !important;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #358696 !important;\r\n  --bs-btn-disabled-bg: transparent;\r\n  --bs-btn-disabled-border-color: #358696 !important;\r\n  --bs-gradient: none;\r\n}\r\n\r\n.kpiSlowBTN .btn-outline-primary:not(:disabled):not(.disabled):active,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.show>.btn-outline-primary.dropdown-toggle {\r\n  /* color: #fff; */\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n/* .kpiSlowBTN .ev_SButton {\r\n    background: none !important;\r\n    color: #348393 !important;\r\n  } */\r\n.kpiSlowBTN .ev_SButton {\r\n  background: none !important;\r\n  color: #7b7878 !important;\r\n  border-color: #7b7878 !important;\r\n}\r\n\r\n.kpiSlowBTN .btn:focus,\r\n.btn:focus-visible,\r\n.btn:focus-within,\r\n.btn:hover,\r\n.btn:visited,\r\n.btn:active,\r\n.btn:target {\r\n  color: #fff !important;\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n.kpiSlowBTN .btn-outline-primary:hover {\r\n  background-color: #358696 !important;\r\n  border-color: #358696 !important;\r\n}\r\n\r\n/*********************** Slow Button Ends *************************/\r\n\r\n\r\n/*********************** Fast Button *************************/\r\n.kpiFastBTN .btn-outline-warning {\r\n  /* color:#FFA650; */\r\n  /* border-color:#FFA650 !important; */\r\n}\r\n\r\n.kpiFastBTN .btn-check:checked+.btn:focus-visible,\r\n.btn.active:focus-visible,\r\n.btn.show:focus-visible,\r\n.btn:first-child:active:focus-visible,\r\n:not(.btn-check)+.btn:active:focus-visible {\r\n  box-shadow: none;\r\n}\r\n\r\n.kpiFastBTN .btn-outline-warning {\r\n  --bs-btn-color: #FFA650 !important;\r\n  --bs-btn-border-color: #FFA650 !important;\r\n  --bs-btn-hover-color: #000;\r\n  --bs-btn-hover-bg: #FFA650 !important;\r\n  --bs-btn-hover-border-color: #FFA650 !important;\r\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\r\n  --bs-btn-active-color: #000;\r\n  --bs-btn-active-bg: #FFA650 !important;\r\n  --bs-btn-active-border-color: #FFA650 !important;\r\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\r\n  --bs-btn-disabled-color: #FFA650 !important;\r\n  --bs-btn-disabled-bg: transparent;\r\n  --bs-btn-disabled-border-color: #FFA650 !important;\r\n  --bs-gradient: none;\r\n}\r\n\r\n/* .kpiFastBTN .ev_FButton {\r\n  background: none !important;\r\n  color: #FFA650 !important;\r\n} */\r\n.kpiFastBTN .ev_FButton {\r\n  background: none !important;\r\n  /* color: #FFA650 !important; */\r\n  /* background: #7b7878 !important; */\r\n  /* border: #7b7878; */\r\n  border-color: #7b7878;\r\n}\r\n\r\n.kpiFastBTN .btn:focus,\r\n.btn:focus-visible,\r\n.btn:focus-within,\r\n.btn:hover,\r\n.btn:visited,\r\n.btn:active,\r\n.btn:target {\r\n  color: #fff !important;\r\n  background-color: #FFA650;\r\n  border-color: #FFA650;\r\n}\r\n\r\n\r\n/*********************** Fast Button Ends *************************/\r\n\r\nhas context menu .bg-white {\r\n  background-color: #fff;\r\n}\r\n\r\n.chargingMainDiv {\r\n  margin-top: 80px;\r\n}\r\n\r\n.chargingWidget {\r\n  background: #fff;\r\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\r\n  border-radius: 5px;\r\n}\r\n\r\n.chargingWidgetIcon img {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.chargingWidgetIcon1 img {\r\n  width: 35px;\r\n  height: 35px;\r\n}\r\n\r\n.chargingWidgetIcon-32 img {\r\n  width: 32px;\r\n  height: 32px;\r\n}\r\n\r\n.chargingTitleBg {\r\n  font-size: 1em;\r\n  color: #0E3157;\r\n  font-weight: 500;\r\n  margin-bottom: 10px;\r\n  text-align: left;\r\n  background: #E0E0E0;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n\r\n.chargingTitleChart {\r\n  font-size: 0.8em;\r\n  color: #0E3157;\r\n  font-weight: 500;\r\n  margin-bottom: 10px;\r\n  text-align: left;\r\n  background: #E0E0E0;\r\n  border-radius: 5px 5px 0 0;\r\n}\r\n\r\n.chargingChartbox {\r\n  background: #FFFFFF;\r\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n  color: #353535;\r\n  min-height: 280px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.wd {\r\n  min-height: 328px !important;\r\n}\r\n\r\n.wd_4_charts {\r\n  min-height: 307px !important;\r\n}\r\n\r\n.highlightBoxKpi {\r\n  min-height: 310px !important;\r\n}\r\n\r\n.highlightTableSec {\r\n  min-height: 310px !important;\r\n}\r\n\r\n.chargingChartHGT {\r\n  padding: 10px;\r\n}\r\n\r\n.chargingH5 .h5 {\r\n  font-size: 1rem !important;\r\n}\r\n\r\n.chargingKpiSmallTxt {\r\n  font-size: 77% !important;\r\n  line-height: 1em !important;\r\n}\r\n\r\n.tableContent table tr td {\r\n  font-size: 0.8em;\r\n}\r\n\r\n.chargingFilterForm>.form-label {\r\n  font-size: 0.825em;\r\n}\r\n\r\n.chargingHeadfont {\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.topRightDropMenu .dropdown-menu[data-bs-popper] {\r\n  right: 0 !important;\r\n  left: auto;\r\n}\r\n\r\n/********************  *********************/\r\n\r\n.contentScroll {\r\n  /* overflow-y: scroll; */\r\n  /* height:150px; */\r\n}\r\n\r\n.chargingWidget p {\r\n  line-height: 1rem !important;\r\n}\r\n\r\n.chargingWidget p small {\r\n  font-size: 80% !important;\r\n}\r\n\r\n/***************************** Toggle Switch ***************************/\r\n.toggleBtn .form-switch .form-check-input:checked:before {\r\n  content: \"F\";\r\n  position: absolute;\r\n  width: 20px;\r\n  height: 10px;\r\n  padding-left: 20px;\r\n  margin-top: -1px;\r\n  font-size: 0.7em;\r\n}\r\n\r\n.toggleBtn .form-switch .form-check-input:before {\r\n  content: \"S\";\r\n  position: absolute;\r\n  width: 20px;\r\n  height: 10px;\r\n  padding-left: 5px;\r\n  margin-top: -1px;\r\n  font-size: 0.7em;\r\n}\r\n\r\n.toggleBtn .form-switch .form-check-input {\r\n  color: #358696 !important;\r\n}\r\n\r\n/* k */\r\n.toggleBtn .toggle-button-cover {\r\n  position: relative;\r\n  top: 8px;\r\n  /* display: table-cell; */\r\n  /* width: 200px; */\r\n  /* height: 140px; */\r\n  /* box-sizing: border-box; */\r\n}\r\n\r\n.dropdownSelectBtnCharging {\r\n  width: fit-content;\r\n}\r\n\r\n.toggleBtn .button-cover {\r\n  /* height: 100px; */\r\n  /* margin: 20px; */\r\n  background-color: #fff;\r\n  box-shadow: 0 10px 20px -8px #c5d6d6;\r\n  border-radius: 4px;\r\n}\r\n\r\n.toggleBtn .button-cover:before {\r\n  /* counter-increment: button-counter; */\r\n  /* content: counter(button-counter); */\r\n  /* position: absolute; */\r\n  /* right: 0; */\r\n  /* bottom: 0; */\r\n  color: #d7e3e3;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  padding: 5px;\r\n}\r\n\r\n.toggleBtn .button-cover,\r\n.knobs,\r\n.layer {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n}\r\n\r\n.toggleBtn .buttonbtn {\r\n  position: relative;\r\n  top: 50%;\r\n  width: 50px;\r\n  /* height: 36px; */\r\n  /* margin: -20px auto 0 auto; */\r\n  /* overflow: hidden; */\r\n}\r\n\r\n.toggleBtn .buttonbtn.r,\r\n.buttonbtn.r .layer {\r\n  border-radius: 100px;\r\n}\r\n\r\n.toggleBtn .button.b2 {\r\n  border-radius: 2px;\r\n}\r\n\r\n.toggleBtn .checkbox {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0;\r\n  margin: 0;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  z-index: 3;\r\n}\r\n\r\n.toggleBtn .knobs {\r\n  z-index: 2;\r\n}\r\n\r\n.toggleBtn .layer {\r\n  width: 100%;\r\n  background-color: #ebf7fc;\r\n  transition: 0.3s ease all;\r\n  z-index: 1;\r\n}\r\n\r\n/* Button 1 */\r\n#button-1 .knobs:before {\r\n  content: \"S\";\r\n  position: absolute;\r\n  /* top: 2px; */\r\n  /* left: 4px; */\r\n  top: 0px;\r\n  left: 0px;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #fff;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  line-height: 1;\r\n  padding: 6px 4px;\r\n  background-color: #358696;\r\n  border-radius: 50%;\r\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\r\n}\r\n\r\n#button-1 .checkbox:checked+.knobs:before {\r\n  content: \"F\";\r\n  /* left: 25px; */\r\n  left: 30px;\r\n  background-color: #FFA650;\r\n}\r\n\r\n#button-1 .checkbox:checked~.layer {\r\n  background-color: #fcebeb;\r\n}\r\n\r\n#button-1 .knobs,\r\n#button-1 .knobs:before,\r\n#button-1 .layer {\r\n  transition: 0.3s ease all;\r\n}\r\n\r\n/* k */\r\n\r\n\r\n/***************************** PageTwo *******************************/\r\n\r\n/*************************  *****************************/\r\n.kpiNotificationSlow {\r\n  color: #358696;\r\n  font-size: 0.7em;\r\n  font-weight: 500;\r\n}\r\n\r\n.kpiNotificationFast {\r\n  color: #FFA650;\r\n  font-size: 0.7em;\r\n  font-weight: 500;\r\n}\r\n\r\n.kpiNotificationBoth {\r\n  color: #72D817;\r\n  font-size: 0.7em;\r\n  font-weight: 500;\r\n}\r\n\r\n/* media queries start here */\r\n\r\n@media (min-width: 1440px) {\r\n  .col205 {\r\n    flex: 0 0 auto;\r\n    width: 20% !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 1440px) {\r\n  .highlightTableSec {\r\n    min-height: 310px !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1336px) {\r\n  .col205 {\r\n    flex: 0 0 auto;\r\n    width: 20% !important;\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 1024px) {\r\n  .highlightTableSec {\r\n    min-height: 330px !important;\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 992px) {\r\n  .col205 {\r\n    flex: 0 0 auto;\r\n    width: 20% !important;\r\n  }\r\n}\r\n\r\n\r\n@media (min-width: 836px) {\r\n  /* .navbar-expand-sm { */\r\n  /* flex-wrap: nowrap !important; */\r\n  /* justify-content: flex-start !important; */\r\n  /* } */\r\n}\r\n\r\n@media screen and (max-width: 740px) {\r\n  .chargingTitleBg {\r\n    font-size: 0.9em;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (max-width: 720px) {\r\n  /* .chargingMainDiv{ */\r\n  /* margin-top:124px; */\r\n  /* } */\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  /* .chargingMainDiv{ */\r\n  /* margin-top:155px; */\r\n  /* } */\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n\r\n  .chargingHeadfont {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .chargingTitleBg {\r\n    font-size: 0.9em;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 320px) {}\r\n\r\n.highlight_five {\r\n  margin: auto;\r\n}\r\n\r\n.text_bottom {\r\n  margin-bottom: '-16px !important';\r\n  display: none;\r\n  z-index: 1;\r\n}\r\n\r\n.btn-infotable:active {\r\n  color: black;\r\n  background-color: #fff;\r\n  border-color: #32879c;\r\n\r\n}\r\n\r\n/* .btn:not(:disabled):not(.disabled) {\r\n  cursor: pointer;\r\n  color: #fff;\r\n  color: black;\r\n  background: none;\r\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
